import { gql } from '@apollo/client';
export const LOGIN = gql `
  mutation LOGIN($input: UserLoginInput!) {
    login(input: $input) {
      success
      mfaRequired
      message
    }
  }
`;
export const LOGOUT = gql `
  mutation LOGOUT($clientCodes: [String!]) {
    logout(clientCodes: $clientCodes) {
      message
      usingGuildAuth
      guildAuthLogoutUrl
    }
  }
`;
